import { useState, useEffect } from "react";
import ioslink from "../images/vid.mp4";
import ioslink2 from "../images/vid2.mp4";

export const VideoData = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const videoSource = screenWidth < 500 ? ioslink2 : ioslink;

  return (
    <div className="video-wrapper">
      <video
        src={videoSource}
        autoPlay
        loop
        muted
        playsInline
        className="responsive-video"
      />
    </div>
  );
};
